import { Download, X } from "lucide-react";
import { PWA } from "@/constants/testIds/pwa";

export default function PwaInstallBanner({ visible, onInstall, onDismiss }) {
  if (!visible) return null;
  return (
    <div
      data-testid={PWA.banner}
      className="w-full bg-brand-rose/12 border-b border-brand-rose/30 text-brand-ink"
    >
      <div className="max-w-7xl mx-auto px-3 py-2 flex items-center gap-2">
        <Download className="w-3.5 h-3.5 text-brand-rose shrink-0" />
        <span className="text-[12.5px] font-ui leading-snug min-w-0 flex-1">
          Me coloca na tela inicial? Assim eu te chamo de manhã com o calendário ✦
        </span>
        <button
          type="button"
          data-testid={PWA.bannerInstall}
          onClick={onInstall}
          className="shrink-0 min-h-[32px] px-3 rounded-full bg-brand-rose hover:bg-brand-roseHover text-white text-[12px] font-ui"
        >
          Baixar o app
        </button>
        <button
          type="button"
          data-testid={PWA.bannerDismiss}
          aria-label="Dispensar"
          onClick={onDismiss}
          className="shrink-0 p-1 rounded-full text-brand-ink3 hover:text-white"
        >
          <X className="w-3.5 h-3.5" />
        </button>
      </div>
    </div>
  );
}
